var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { isElement, isReactComponent } from '../is';
export var render = function (Node, Wrapper, props) {
    if (Wrapper === void 0) { Wrapper = React.Fragment; }
    if (isElement(Node)) {
        return React.createElement(Wrapper, __assign({}, props), Node);
    }
    if (typeof Node === 'function') {
        return Node(props);
    }
    if (isReactComponent(Node)) {
        return React.createElement(Node, props);
    }
    return Node;
};
//# sourceMappingURL=render.js.map